import Environment from '@/constants/core/Environment'
import { getLogger } from '@/services/logging/AppLogger'

export default {
  install(Vue, environment) {
    if (environment === Environment.production && !Vue.prototype.$appInsights) {
      throw new Error(
        '[LoggerPlugin] $appInsights is not initialized. Make sure AppInsightsPlugin is registered first.'
      )
    }

    const logger = getLogger(Vue.prototype.$appInsights)
    Vue.prototype.$logger = logger
  },
}
